let userAuthenticated = () => {
  return localStorage.getItem("access-token");
}

export default {
  userAuthenticated
}